// extracted by mini-css-extract-plugin
export default {"okay":"sn_okay__xHJtx","bg":"sn_bg__mNpiL","displayN":"sn_displayN__5xV37","con":"sn_con__xRHvC","h":"sn_h__NVexR","b":"sn_b__aMQ7N"};